var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
var Cart = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M7,6.01027255 L7,6 L21.162865,6 L18.8771507,14 L9.69070884,14 L10.3642509,16 L19,16 L19,17 L9.64583728,17 L5.60458477,5 L2,5 L2,4 L6.32299842,4 L7,6.01027255 Z M7.33331154,7 L9.3539378,13 L18.1228493,13 L19.837135,7 L7.33331154,7 Z M17.5,19 C17.2238576,19 17,19.2238576 17,19.5 C17,19.7761424 17.2238576,20 17.5,20 C17.7761424,20 18,19.7761424 18,19.5 C18,19.2238576 17.7761424,19 17.5,19 Z M17.5,18 C18.3284271,18 19,18.6715729 19,19.5 C19,20.3284271 18.3284271,21 17.5,21 C16.6715729,21 16,20.3284271 16,19.5 C16,18.6715729 16.6715729,18 17.5,18 Z M10.5,19 C10.2238576,19 10,19.2238576 10,19.5 C10,19.7761424 10.2238576,20 10.5,20 C10.7761424,20 11,19.7761424 11,19.5 C11,19.2238576 10.7761424,19 10.5,19 Z M10.5,18 C11.3284271,18 12,18.6715729 12,19.5 C12,20.3284271 11.3284271,21 10.5,21 C9.67157288,21 9,20.3284271 9,19.5 C9,18.6715729 9.67157288,18 10.5,18 Z" })));
};
Cart.displayName = 'Cart';
export default Cart;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=Cart.js.map